import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContentText,
  Theme,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialogContent } from 'shell/components/shared/dialog/content';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

const useStyles = makeStyles((theme: Theme) => ({
  paper: { minWidth: '30rem', color: theme.palette.cdmBrand.main },
}));

interface ErrorModalProps {
  id?: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
}

const ErrorModalWithHtml = ({
  id = 'error',
  open,
  message,
  title = 'Attenzione!',
  onClose,
  onConfirm,
}: ErrorModalProps): React.ReactElement => {
  const classes = useStyles();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <Dialog
      open={open}
      aria-labelledby={id}
      aria-describedby={id}
      classes={{ paper: classes.paper }}
      fullScreen={fullScreen}
    >
      <PmiDialogTitle id={`${id}-title`} color="white" backgroundColor="cdmBrand">
        {title}
      </PmiDialogTitle>
      <PmiDialogContent>
        <DialogContentText key={message} id={`${id}-content`} sx={{ whiteSpace: 'pre-line' }}>
          <div dangerouslySetInnerHTML={{ __html: message }} />
        </DialogContentText>
      </PmiDialogContent>
      <DialogActions>
        <PmiButton onClick={onConfirm} variant="contained" color="primary">
          Si
        </PmiButton>
        <PmiButton onClick={onClose} variant="outlined" color="cdmBrand">
          No
        </PmiButton>
      </DialogActions>
    </Dialog>
  );
};

ErrorModalWithHtml.displayName = 'Error modal with html component';

export default ErrorModalWithHtml;
